import { ArrowRightOutlined } from '@ant-design/icons';
import React, { FC } from 'react';

export interface AuditChangeElementProps {
	resolvedFieldName: string;
	fieldName: string;
	resolvedOldValue: string;
	oldValue: string;
	resolvedNewValue: string;
	newValue: string;
}

const AuditChangeComponent: FC<AuditChangeElementProps> = ({
	resolvedFieldName,
	fieldName,
	resolvedOldValue,
	oldValue,
	resolvedNewValue,
	newValue,
}): React.ReactElement => {
	return (
		<span className="inline-block rounded-md bg-violet-100 p-2 text-sm text-gray-500">
			{resolvedFieldName || fieldName} : {resolvedOldValue || oldValue || `' '`}{' '}
			<ArrowRightOutlined /> {resolvedNewValue || newValue || `' '`}
		</span>
	);
};

export default AuditChangeComponent;
